var _style, _desc, _g, _g2, _defs, _path, _g3, _defs2, _path2, _g4, _defs3, _path3, _path4, _g5, _defs4, _path5, _g6, _g7, _g8, _defs5, _rect, _g9, _defs6, _path6, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264 280",
    style: {
      enableBackground: "new 0 0 264 280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#react-mask-4_00000003096251890647503270000011179190222735830447_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#65C9FF;}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000035528170640657041740000017896791068883672969_);}\n\t.st6{mask:url(#react-mask-5_00000028324193956171254050000017084849038633366955_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#D0C6AC;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000033362010924935840420000013192536282788086161_);}\n\t.st9{mask:url(#react-mask-6_00000113350759598605179610000016528804125650441613_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#EDB98A;}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_00000029764462305463463350000000981916533058685573_);}\n\t\n\t\t.st12{mask:url(#react-mask-6_00000129165083507322590360000006992400002922589602_);fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\n\t.st13{filter:url(#Adobe_OpacityMaskFilter_00000091013025386854012430000017789505568886572213_);}\n\t.st14{mask:url(#react-mask-122_00000172412059502476977470000017748851563623587765_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#FF5C5C;}\n\t.st16{fill-opacity:0.6;}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.16;}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.6;}\n\t.st19{filter:url(#Adobe_OpacityMaskFilter_00000146478324978965087950000003972197002065696660_);}\n\t.st20{mask:url(#react-mask-197_00000088098727990745392500000014526863405919832760_);}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#944F23;}\n\t.st22{filter:url(#Adobe_OpacityMaskFilter_00000063635462567786899070000006828758441930538636_);}\n\t.st23{mask:url(#react-mask-198_00000135673536215357807700000005730027284601201085_);}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#4A312C;}\n\t.st25{opacity:0.44;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;fill-opacity:0.16;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#FFBB40;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#F4F4F4;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with getavataaars.com")), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar_00000065796215979367182250000005491246038490231988_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avataaar_x2F_Circle",
    transform: "translate(-825.000000, -1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(825.000000, 1100.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Background"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "react-path-1_00000103960114501456583410000006142591543909115817_",
    className: "st0",
    cx: 120,
    cy: 120,
    r: 120
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    id: "react-mask-4_00000003096251890647503270000011179190222735830447_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "react-path-1_00000178920435230355788560000011915918682980030872_",
    className: "st2",
    cx: 120,
    cy: 120,
    r: 120
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Color_x2F_Palette_x2F_Blue-01",
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_xD83D__xDD8D_Color",
    className: "st4",
    width: 240,
    height: 240
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000029742764454656364940000001495674316914422714_",
    filterUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 297,
    height: 316
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 297,
    height: 316,
    id: "react-mask-5_00000028324193956171254050000017084849038633366955_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000029742764454656364940000001495674316914422714_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "react-path-2_00000098219618304863116370000006967832457896736643_",
    className: "st2",
    d: "M12,160c0,66.3,53.7,120,120,120 s120-53.7,120-120h12V0H0v160H12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.000000, 36.000000)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "react-path-3_00000108987819984865407910000015250022326970541698_",
    className: "st7",
    d: "M124,144.6V163h4l0,0 c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74 c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14 c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118366057740259766260000001192834568177812639_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280,
    id: "react-mask-6_00000113350759598605179610000016528804125650441613_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000118366057740259766260000001192834568177812639_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "react-path-3_00000154418534817781539440000002013884556085523850_",
    className: "st2",
    d: "M124,144.6V163h4l0,0 c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74 c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14 c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Skin_x2F__xD83D__xDC76__xD83C__xDFFD_-03-Brown",
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    width: 264,
    height: 280
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156589576808393744520000011346450968514782091_",
    filterUnits: "userSpaceOnUse",
    x: 44,
    y: 79,
    width: 112,
    height: 79
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 79,
    width: 112,
    height: 79,
    id: "react-mask-6_00000129165083507322590360000006992400002922589602_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156589576808393744520000011346450968514782091_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "react-path-3_00000161603119153266277120000007040886030239883187_",
    className: "st2",
    d: "M124,144.6V163h4l0,0 c39.8,0,72,32.2,72,72v9H0v-9c0-39.8,32.2-72,72-72l0,0h4v-18.4c-17.2-8.2-29.6-24.9-31.7-44.7C38.5,99.1,34,94.1,34,88V74 c0-5.9,4.3-10.9,10-11.8V56l0,0c0-30.9,25.1-56,56-56l0,0l0,0c30.9,0,56,25.1,56,56v6.2c5.7,1,10,5.9,10,11.8v14 c0,6.1-4.5,11.1-10.3,11.9C153.6,119.7,141.2,136.4,124,144.6z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    className: "st12",
    d: "M156,79v23c0,30.9-25.1,56-56,56s-56-25.1-56-56V79v15c0,30.9,25.1,56,56,56 s56-25.1,56-56V79z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clothing_x2F_Shirt-Scoop-Neck",
    transform: "translate(0.000000, 170.000000)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Clothes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-121_00000147938844921941004620000017508057145631639482_",
    className: "st0",
    d: "M181.5,32.3 c29.2,9.2,50.5,36.5,50.5,68.7v8.9H32v-8.9c0-32.7,21.7-60.2,51.5-69c-0.4,1.4-0.5,2.9-0.5,4.3c0,16.3,22.2,29.5,49.5,29.5 S182,52.6,182,36.3C182,35,181.8,33.6,181.5,32.3z"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000037682981285449784060000004068554518449230212_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 110
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 110,
    id: "react-mask-122_00000172412059502476977470000017748851563623587765_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000037682981285449784060000004068554518449230212_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "react-path-121_00000038400668200180361180000015046400006583990177_",
    className: "st2",
    d: "M181.5,32.3 c29.2,9.2,50.5,36.5,50.5,68.7v8.9H32v-8.9c0-32.7,21.7-60.2,51.5-69c-0.4,1.4-0.5,2.9-0.5,4.3c0,16.3,22.2,29.5,49.5,29.5 S182,52.6,182,36.3C182,35,181.8,33.6,181.5,32.3z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Color_x2F_Palette_x2F_Gray-01",
    className: "st14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_xD83D__xDD8D_Color_00000062193675482285323770000005681103064017593234_",
    className: "st15",
    width: 264,
    height: 110
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(76.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth_x2F_Twinkle",
    transform: "translate(2.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    className: "st16",
    d: "M40,16c0,5.4,6.2,9,14,9s14-3.6,14-9c0-1.1-0.9-2-2-2c-1.3,0-1.9,0.9-2,2 c-1.2,2.9-4.3,4.7-10,5c-5.7-0.3-8.8-2.1-10-5c-0.1-1.1-0.7-2-2-2C40.9,14,40,14.9,40,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Nose_x2F_Default",
    transform: "translate(28.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    className: "st17",
    d: "M16,8c0,4.4,5.4,8,12,8l0,0c6.6,0,12-3.6,12-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes_x2F_Default-_xD83D__xDE00_",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    className: "st18",
    cx: 30,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Eye_00000104689111957679183280000010810400364378820509_",
    className: "st18",
    cx: 82,
    cy: 22,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow_x2F_Outline_x2F_Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I-Browse",
    transform: "translate(12.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    className: "st16",
    d: "M3.6,11.2c3.9-5.5,14.6-8.6,23.9-6.3c1.1,0.3,2.2-0.4,2.4-1.5c0.3-1.1-0.4-2.2-1.5-2.4 C17.7-1.7,5.3,1.9,0.4,8.8c-0.6,0.9-0.4,2.1,0.5,2.8S3,12.1,3.6,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow_00000036236747193185666640000014112446169646149521_",
    className: "st16",
    d: "M84.4,11.2 c-3.9-5.5-14.6-8.6-23.9-6.3c-1.1,0.3-2.2-0.4-2.4-1.5s0.4-2.2,1.5-2.4c10.7-2.6,23.2,0.9,28.1,7.9c0.6,0.9,0.4,2.1-0.5,2.8 S85,12.1,84.4,11.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Top_00000042702996525819347050000011412899998345953951_"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_00000170268065956053582050000007712320612183763609_"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000017503489962419804090000016029462972137931922_",
    filterUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 264,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 264,
    height: 280,
    id: "react-mask-197_00000088098727990745392500000014526863405919832760_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000017503489962419804090000016029462972137931922_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "react-path-199_00000123398788469858549340000005595904462024851132_",
    className: "st2",
    width: 264,
    height: 280
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top_x2F_Long-Hair_x2F_Long-but-not-too-long",
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Behind"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-200_00000050629283218364261550000014226500671012055448_",
    className: "st21",
    d: "M59,102.3 c0,16.6,0,43.1,0,79.7c0,4.4,3.6,8,8,8h42v-9.4c-17.5-8.3-30-25.5-31.8-45.7C71.4,134,67,129,67,123v-13 c0-3.5,1.5-6.6,3.9-8.8c11.5-2.6,24.1-7.5,36.5-14.7c12.1-7,22.5-15.2,30.5-23.7c-3.4,7.9-7.6,14.8-12.4,20.8 c12.7-5.5,21.3-14.4,25.9-26.6c0.4,0.9,0.8,1.8,1.2,2.8c10.3,23,27.9,39.4,45.8,44.7c0.5,2.1,0.8,4.1,0.8,5.6v13 c0,6-4.4,11-10.2,11.9c-1.7,20.2-14.3,37.4-31.8,45.7v9.4h18c17.7,0,32-14.3,32-32c0-24.1,0-42.1,0-54.1c0-0.1,0-0.2,0-0.3 c-0.1-12.3-0.3-19.4-0.6-21.4C201.6,46,170.6,18,133,18c-36.1,0-66.1,25.8-73,60c-5.5,0-10,5.6-10,12.5 c0,4.6,1.7,8.6,4.9,10.8C55.8,101.9,57.3,102.2,59,102.3z"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000081644463872814128900000009197140874364937887_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 264,
    height: 280,
    id: "react-mask-198_00000135673536215357807700000005730027284601201085_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000081644463872814128900000009197140874364937887_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "react-path-200_00000124843994399149395400000004957804802784655273_",
    className: "st2",
    d: "M59,102.3 c0,16.6,0,43.1,0,79.7c0,4.4,3.6,8,8,8h42v-9.4c-17.5-8.3-30-25.5-31.8-45.7C71.4,134,67,129,67,123v-13 c0-3.5,1.5-6.6,3.9-8.8c11.5-2.6,24.1-7.5,36.5-14.7c12.1-7,22.5-15.2,30.5-23.7c-3.4,7.9-7.6,14.8-12.4,20.8 c12.7-5.5,21.3-14.4,25.9-26.6c0.4,0.9,0.8,1.8,1.2,2.8c10.3,23,27.9,39.4,45.8,44.7c0.5,2.1,0.8,4.1,0.8,5.6v13 c0,6-4.4,11-10.2,11.9c-1.7,20.2-14.3,37.4-31.8,45.7v9.4h18c17.7,0,32-14.3,32-32c0-24.1,0-42.1,0-54.1 c0-0.1,0-0.2,0-0.3c-0.1-12.3-0.3-19.4-0.6-21.4C201.6,46,170.6,18,133,18c-36.1,0-66.1,25.8-73,60c-5.5,0-10,5.6-10,12.5 c0,4.6,1.7,8.6,4.9,10.8C55.8,101.9,57.3,102.2,59,102.3z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Skin_x2F__xD83D__xDC76__xD83C__xDFFD_-03-Brown_00000052084723029480495050000008571554975005891731_",
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_00000124129342002575111740000008694816449039945622_",
    transform: "translate(0.000000, 0.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    width: 264,
    height: 280
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(50.000000, 18.000000)",
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_00000041254242863090630380000000900076954105923201_",
    className: "st26",
    d: "M11.9,84.8 c13.8-1.8,29.8-7.2,45.4-16.3c12.1-7,22.5-15.2,30.5-23.7c-3.4,7.9-7.6,14.8-12.4,20.8C88,60,96.7,51.1,101.3,38.9 c0.4,0.9,0.8,1.8,1.2,2.8c11.9,26.8,33.9,44.5,54.6,46.5l0,0V74c0-40.9-33.1-74-74-74C46.9,0,16.9,25.8,10.3,60 c-0.1,0-0.2,0-0.3,0C4.5,60,0,65.6,0,72.5C0,79,3.9,84.3,9,84.9v0.2c0.3,0,0.6-0.1,1-0.1c0,0,0,0,0,0 C10.6,85,11.3,84.9,11.9,84.8z"
  })))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Clothing_x2F_Shirt-Crew-Neck",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-64_00000071555978473832641790000002779238681584771489_",
    className: "st15",
    d: "M132.8-164.9L132.8-164.9 c36.5,0,66,24.4,66,54.5v4.1h-132v-4.1C66.8-140.5,96.3-164.9,132.8-164.9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st27",
    points: "60.2,58.4 68.9,17.6 82.2,34.1 108.5,8.5 132.4,28.8 156.4,8.5 181.9,32.4 194.4,16.7 204.6,58.4 60.2,58.4  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hat-front_00000038404972276654071500000007814822631956249762_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "react-path-65_00000112604342975070568350000008431800845920269231_",
    className: "st28",
    d: "M59.2,57.7 c17.7-7.4,42.2-11.1,73.2-11.1s55.4,3.7,73.1,11.1l0,0c2.3,1,3.7,2.5,3.7,4.1v19.4c0,1.4-2,2.5-4.5,2.5c-0.9,0-1.7-0.1-2.3-0.4 c-18.5-6.7-41.5-10.1-69.1-10.1c-27.7,0-51.4,3.4-70.9,10.2l0,0c-2.1,0.7-4.8,0.3-6.1-0.8c-0.4-0.4-0.7-0.8-0.7-1.3V61.8 C55.6,60.2,56.9,58.6,59.2,57.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "react-path-65_00000010271454137036500080000000292508197403659933_",
    className: "st29",
    d: "M59.2,57.7 c17.7-7.4,42.2-11.1,73.2-11.1s55.4,3.7,73.1,11.1l0,0c2.3,1,3.7,2.5,3.7,4.1v19.4c0,1.4-2,2.5-4.5,2.5c-0.9,0-1.7-0.1-2.3-0.4 c-18.5-6.7-41.5-10.1-69.1-10.1c-27.7,0-51.4,3.4-70.9,10.2l0,0c-2.1,0.7-4.8,0.3-6.1-0.8c-0.4-0.4-0.7-0.8-0.7-1.3V61.8 C55.6,60.2,56.9,58.6,59.2,57.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueen);
export default __webpack_public_path__ + "static/media/Queen.6b8eab9d00cdfb5411c0631f1a564560.svg";
export { ForwardRef as ReactComponent };